import { Container, Skeleton } from "@mantine/core";
import { useLocation } from "react-router-dom";
import { CategorySkeleton } from "@/components/category/CategorySkeleton";
import styles from "./styles/RouteSkeleton.module.css";

const placeholders = (count: number) => Array.from({ length: count }, (_, i) => i);

const EpisodeRowsSkeleton = ({ count }: { count: number }) => (
    <div className={styles.rows}>
        {placeholders(count).map((i) => (
            <div className={styles.row} key={i}>
                <Skeleton className={styles.thumb} radius="md" />
                <div className={styles.rowText}>
                    <Skeleton height={16} width="70%" />
                    <Skeleton height={12} width="40%" />
                </div>
            </div>
        ))}
    </div>
);

const PodcastSkeleton = () => (
    <div aria-busy="true" aria-label="Laddar podcast">
        <div className={styles.hero}>
            <Skeleton className={styles.cover} radius="lg" />
            <div className={styles.heroText}>
                <Skeleton height={36} width="60%" />
                <Skeleton height={14} width="30%" />
                <Skeleton height={14} width="90%" />
                <Skeleton height={14} width="80%" />
            </div>
        </div>
        <EpisodeRowsSkeleton count={6} />
    </div>
);

const GridSkeleton = () => (
    <div aria-busy="true" aria-label="Laddar sidan">
        <Skeleton height={40} mb="lg" width="40%" />
        <div className={styles.grid}>
            {placeholders(12).map((i) => (
                <div key={i}>
                    <Skeleton className={styles.square} radius="md" />
                    <Skeleton height={14} mt={8} width="80%" />
                </div>
            ))}
        </div>
    </div>
);

/** Route-level Suspense fallback shaped like the page being loaded, so content does not jump in. */
export const RouteSkeleton = () => {
    const { pathname } = useLocation();

    // The route Suspense sits above Layout, so the container is repeated here to keep the same width
    return (
        <Container size="lg">
            {pathname.startsWith("/kategori/") ? (
                <CategorySkeleton />
            ) : pathname.startsWith("/podd/") ? (
                <PodcastSkeleton />
            ) : (
                <GridSkeleton />
            )}
        </Container>
    );
};
